// extracted by mini-css-extract-plugin
export var button = "_fk-4";
export var hasDarkBackground = "_fk-7";
export var hasLightBackground = "_fk-6";
export var iconWrapper = "_fk-0";
export var large = "_fk-2";
export var medium = "_fk-1";
export var small = "_fk-5";
export var xsmall = "_fk-3";